export default class Transform {
    constructor(mv) {
        this.$mv = mv.$mv;
        this.$logo = mv.$logo;
        this.$catches = this.$mv.querySelectorAll('.mv__catch');

        this._init();
    }

    _init() {
        // ルート要素にカスタム変数としてベネッセヘッダーの高さを設定
        this._setProperty();
        // イベントリスナーの追加
        this._addMultiEvent();
    }

    _setProperty() {
        const $root = document.documentElement,
            top = window.scrollY + this.$mv.getBoundingClientRect().top;

        $root.style.setProperty('--headerHeight', `${top}px`);
    }

    _addMultiEvent() {
        // DOM 読込・リサイズ時は比率に応じてメインビジュアルを縮小
        this._setTransform();
        window.addEventListener('load', () => {
            this._setTransform();
        });
        window.addEventListener('resize', () => this._setTransform());
    }

    _setTransform(transformCount = 0) {
        if ((this.$mv.clientHeight === 0 || this.$mv.clientWidth === 0) && transformCount <= 10) {
            setTimeout(() => this._setTransform(transformCount + 1), 100);
            return;
        }

        // NodeListをループして、各.catch要素に対してtransformを適用
        this.$catches.forEach(($catch) => {
            const catchWidth = parseInt(getComputedStyle($catch).width),
                mvMaxHeight = parseInt(getComputedStyle(this.$mv).maxHeight),
                ratioX = this.$mv.clientWidth / catchWidth,
                ratioY = this.$mv.clientHeight / mvMaxHeight,
                ratio = ratioX > ratioY ? ratioY : ratioX;

            MAIN.isNarrow = window.matchMedia('(max-width: 767px)').matches;
            this.$logo.style.transform = MAIN.isNarrow ? 'none' : `scale(${ratio})`;
            $catch.style.transform = `translateX(-50%) scale(${ratio})`;
        });
    }
}
